import { useRef } from 'react';
import { useIntersection } from '../utility/useIntersection';
import useAnalytics from './useAnalytics';
import { DealEventProps } from '../../utils/analytics/dealEventProps';
import { DEDUPE_NAMESPACES, markOnce } from '../../utils/analytics/sessionDedupe';

// Returns a ref to attach to a deal card's root element. Fires offer_impression
// the first time the card becomes visible, at most once per session per offer.
export default function useOfferImpression(analytics?: DealEventProps) {
  const ref = useRef(null);
  const { trackOfferImpression } = useAnalytics();

  useIntersection(ref, { threshold: 0.5 }, !analytics, (visible) => {
    if (visible && analytics && markOnce(DEDUPE_NAMESPACES.Impression, analytics.offer_id)) {
      trackOfferImpression(analytics);
    }
  });

  return ref;
}
